import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { TokenInfoService } from '../services/auth/token-info.service';
import { AppConfig } from '../app.config';
import { WindowRef } from '../services/window-ref/window.ref';

declare const $: any;

@Component({
  selector: 'app-account-menu',
  templateUrl: './account-menu.component.html'
})

export class AccountMenuComponent implements OnInit {
  loggedIn = false;
  avatarURL: string;
  username: string;
  introPageURL: string;

  constructor(
    private authService: AuthService,
    private appConfig: AppConfig,
    private tokenInfoService: TokenInfoService,
    private elementRef: ElementRef,
    private windowRef: WindowRef
  ) {
    this.introPageURL = this.windowRef.location.protocol + '//' + this.windowRef.location.host + '/intro/index.html';
  }

  ngOnInit() {
    this.injectLoginMenuContainer();

    this.setLoginIconPosition();
    this.handleClickOutsideMenu();
    this.sleep(2000).then(() => {
      console.log('displayed');
      this.loginSetup();
    });
  }

  sleep (time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  loginSetup() {
    console.log('enableWidget');
    this.loggedIn = this.authService.isLoggedIn();
    if (this.loggedIn) {
      const tokenInfo = this.tokenInfoService.getSavedTokenInfo();
      if (tokenInfo) {
        this.avatarURL = tokenInfo.Picture;
        this.username = tokenInfo.Email;
      }
    }
  }

  async logout() {
    await this.authService.logout();
  }

  toggleMenu() {
    $('#qg-login-menu').toggle();
    $('#qg-login-trigger').toggleClass('expanded');
  }

  injectLoginMenuContainer() {
    $('#qg-site-header').addClass('with-avatar');

    // Temporary login location until included in SWE
    $('#qg-site-nav').after('\
            <div class="hidden-md hidden-lg" id="qg-avatar-container-menu">\
              <div id="qg-avatar"></div>\
            </div>');

    $(this.elementRef.nativeElement).appendTo('#qg-avatar').removeClass('hidden');
  }

  handleClickOutsideMenu() {
    $(document).click(function(e) {
      const container = $('#qg-login-container');

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        if ($('#qg-login-menu:visible')) {
          $('#qg-login-menu').hide();
          $('#qg-login-trigger').removeClass('expanded');
        }
      }
    });
  }

  setLoginIconPosition () {
    const breakpoints = {
      bsXs: 480,
      bsSm: 768,
      bsMd: 992,
      bsLg: 1200
    };

    const avatarSelector = '#qg-avatar';
    const avatarContainerSelector = '#qg-avatar-container-menu';

    const $loginIcon = $(avatarSelector);
    if (window.innerWidth >= breakpoints.bsMd) {
      $('#qg-site-nav').after($loginIcon);
    } else {
      $loginIcon.appendTo($(avatarContainerSelector));
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setLoginIconPosition();
  }
}



// WEBPACK FOOTER //
// ./app/account-menu/account-menu.component.ts